import { Howler, Howl } from 'howler';
import eventHub from './eventHub';

const audio = {
  sounds: [
    {
      id: 'background',
      file: '/assets/audio/background.mp3',
      ref: null,
      loop: true,
      volume: 0.5,
    },
    {
      id: 'button',
      file: '/assets/audio/button.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'full',
      file: '/assets/audio/full.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'gameover',
      file: '/assets/audio/gameover.mp3',
      ref: null,
      loop: false,
      volume: 4,
    },
    {
      id: 'jump',
      file: '/assets/audio/jump.mp3',
      ref: null,
      loop: false,
      volume: 10,
    },
    {
      id: 'ending',
      file: '/assets/audio/ending.mp3',
      ref: null,
      loop: false,
      volume: 0.5,
    },
    {
      id: 'obstacle',
      file: '/assets/audio/obstacle.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'fuel',
      file: '/assets/audio/fuel.mp3',
      ref: null,
      loop: false,
      volume: 0.15,
    },
    {
      id: 'countdown',
      file: '/assets/audio/countdown.mp3',
      ref: null,
      loop: false,
      volume: 0.2,
    },
    {
      id: 'butterfly',
      file: '/assets/audio/butterfly.mp3',
      ref: null,
      loop: false,
      volume: 0.1,
    },
    {
      id: 'enemy',
      file: '/assets/audio/enemy.mp3',
      ref: null,
      loop: false,
      volume: 0.4,
    },
    {
      id: 'record',
      file: '/assets/audio/record.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'bubble',
      file: '/assets/audio/bubble.mp3',
      ref: null,
      loop: false,
      volume: 1,
    },
    {
      id: 'shield',
      file: '/assets/audio/shield.mp3',
      ref: null,
      loop: false,
      volume: 0.5,
    },
    // {
    //   id: 'start',
    //   file: '/assets/audio/backgroud.mp3',
    //   ref: null,
    //   loop: true,
    //   volume: 1,
    // },
  ],

  init() {
    audio.sounds.forEach((s) => {
      s.ref = new Howl({ src: [s.file], loop: s.loop, volume: s.volume });
      s.promise = () => new Promise((resolve) => s.ref.once('load', resolve));
    });

    eventHub.$on('unmute', audio.unmute);
    eventHub.$on('mute', audio.mute);
  },

  load() {
    return new Promise((resolve) => {
      const promises = [];
      audio.sounds.forEach((s) => promises.push(s.promise()));

      Promise.all(promises).then(resolve);
    });
  },

  get(id) {
    return audio.sounds.find((s) => s.id === id).ref;
  },

  play(id) {
    audio.get(id).play();
  },

  stop(id) {
    audio.get(id).pause();
  },

  mute() {
    Howler.mute(true);
  },

  unmute() {
    Howler.mute(false);
  },
};

export default audio;
